// $(document).ready(function() {
//     // Initialize the text slider within the unique brand-quote-slider
//     $('.brand-quote-slider .text-slider').slick({
//         arrows: false,
//         fade: true,
//         asNavFor: '.brand-quote-slider .image-nav',
//         speed: 1000,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         infinite: true,
//       adaptiveHeight:true,
//         // rtl: true
//     });

//     // Initialize the image navigation within the unique brand-quote-slider
//     $('.brand-quote-slider .image-nav').slick({
//         slidesToShow: 5, 
//         slidesToScroll: 1,
//         asNavFor: '.brand-quote-slider .text-slider',
//         dots: false,
//         focusOnSelect: true,
//         centerMode: true, // Enable center mode
//         centerPadding: '10px', // Adjust this value to control padding around center slide
//         autoplay: true,
//         autoplaySpeed: 3000,
//         speed: 1000,
//         infinite: true,
//         arrows: false,
//         // rtl: true,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 5,
//                     centerMode: true
//                 }
//             },
//             {
//                 breakpoint: 768,
//                 settings: {
//                     slidesToShow: 4,
//                     centerMode: true
//                 }
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 3,
//                     centerMode: true,
//                 }
//             }
//         ]
//     });
// });

// Fix is-light incorrectly restoring on collection pages
if (document.body.classList.contains('template-collection')) {
  const hw = document.getElementById('HeaderWrapper');
  if (hw) hw.dataset.wasLight = 'false';
}

// Attitude card expand on + click
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.attitude-grid__card-btn');
  if (!btn) {
    // Click outside — close all open cards
    document.querySelectorAll('.attitude-grid__card.is-open').forEach(function(c) {
      c.classList.remove('is-open');
    });
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  var card = btn.closest('.attitude-grid__card');
  var isOpen = card.classList.contains('is-open');
  // Close all first
  document.querySelectorAll('.attitude-grid__card.is-open').forEach(function(c) {
    c.classList.remove('is-open');
  });
  if (!isOpen) card.classList.add('is-open');
});

// Sibling swatch image swap + size stack on collection tiles
(function () {
  // Capture original tile state on first interaction
  function captureOriginalState(tile) {
    if (tile.dataset.boOriginalCaptured === 'true') return;

    var imgs = tile.querySelectorAll('.grid-product__image-mask img');
    var originalImages = [];
    imgs.forEach(function (img) {
      if (img.closest('.plusLink')) return;
      originalImages.push({
        el: img,
        src: img.src,
        srcset: img.srcset,
        sizes: img.sizes
      });
    });
    tile.boOriginalImages = originalImages;

    var link = tile.querySelector('.grid-product__link');
    tile.boOriginalLink = link ? link.href : null;

    var colourNameEl = tile.querySelector('.bo-colour-name');
    tile.boOriginalColourName = colourNameEl ? colourNameEl.textContent : null;

    // Capture original size stack HTML for restore
    var sizeStack = tile.querySelector('.bo-size-stack');
    tile.boOriginalSizeStackHTML = sizeStack ? sizeStack.innerHTML : null;
    tile.boOriginalSizeStackProductId = sizeStack ? sizeStack.dataset.productId : null;

    tile.dataset.boOriginalCaptured = 'true';
  }

  function revertTile(tile) {
    if (!tile.boOriginalImages) return;

    tile.boOriginalImages.forEach(function (state) {
      state.el.src = state.src;
      if (state.srcset) state.el.srcset = state.srcset;
      if (state.sizes) state.el.sizes = state.sizes;
    });

    var link = tile.querySelector('.grid-product__link');
    if (link && tile.boOriginalLink) link.href = tile.boOriginalLink;

    var colourNameEl = tile.querySelector('.bo-colour-name');
    if (colourNameEl && tile.boOriginalColourName) {
      colourNameEl.textContent = tile.boOriginalColourName;
    }

    // Revert size stack
    var sizeStack = tile.querySelector('.bo-size-stack');
    if (sizeStack && tile.boOriginalSizeStackHTML !== null) {
      sizeStack.innerHTML = tile.boOriginalSizeStackHTML;
      if (tile.boOriginalSizeStackProductId) {
        sizeStack.dataset.productId = tile.boOriginalSizeStackProductId;
      }
    }

    // Revert active swatch to the original product
    var originalProductId = tile.dataset.productId;
    tile.querySelectorAll('.bo-sibling-swatch').forEach(function (s) {
      s.classList.toggle('is-active', s.dataset.siblingId === originalProductId);
    });
  }

  function rebuildSizeStack(tile, variantsJson, newProductId) {
    var sizeStack = tile.querySelector('.bo-size-stack');
    if (!sizeStack) return;

    var variants;
    try {
      variants = JSON.parse(variantsJson);
    } catch (err) {
      console.error('[bo] failed to parse sibling variants', err);
      return;
    }

    sizeStack.innerHTML = '';
    sizeStack.dataset.productId = newProductId;

    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bo-size' + (v.available ? '' : ' is-sold-out');
      btn.dataset.variantId = v.id;
      btn.dataset.sizeLabel = v.option1 || v.title;
      if (!v.available) btn.disabled = true;

      var label = document.createElement('span');
      label.className = 'bo-size__label';
      label.textContent = v.option1 || v.title;

      var addLabel = document.createElement('span');
      addLabel.className = 'bo-size__add';
      addLabel.textContent = '+';

      btn.appendChild(label);
      btn.appendChild(addLabel);
      sizeStack.appendChild(btn);
    });
  }

  // Swatch click handler
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.bo-sibling-swatch');
    if (!swatch) return;
    if (swatch.classList.contains('is-sold-out')) return;

    e.preventDefault();
    e.stopPropagation();

    var tile = swatch.closest('.grid-product');
    if (!tile) return;

    captureOriginalState(tile);

    var newImage = swatch.dataset.siblingImage;
    var newUrl = swatch.dataset.siblingUrl;
    var newColourName = swatch.dataset.siblingName;
    var newProductId = swatch.dataset.siblingId;
    var variantsJson = swatch.dataset.siblingVariants;

    var imgs = tile.querySelectorAll('.grid-product__image-mask img');
    imgs.forEach(function (img) {
      if (img.closest('.plusLink')) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = newImage;
    });

    var link = tile.querySelector('.grid-product__link');
    if (link && newUrl) link.href = newUrl;

    var colourNameEl = tile.querySelector('.bo-colour-name');
    if (colourNameEl && newColourName) colourNameEl.textContent = newColourName;

    if (variantsJson) rebuildSizeStack(tile, variantsJson, newProductId);

    tile.querySelectorAll('.bo-sibling-swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
  });

  // Size click → add to cart
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.bo-size');
    if (!sizeBtn) return;
    if (sizeBtn.classList.contains('is-sold-out')) return;
    if (sizeBtn.classList.contains('is-adding')) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = sizeBtn.dataset.variantId;
    if (!variantId) return;

    sizeBtn.classList.add('is-adding');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function(err) { throw err; });
        return r.json();
      })
      .then(function (item) {
        sizeBtn.classList.remove('is-adding');
        

        // Tell Archetype's cart system to rebuild (this refreshes the drawer contents)
        if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
          window.theme.cart.getCart();
        }

        // Dispatch Archetype's standard cart events
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function (err) {
        console.error('[bo] add to cart error', err);
        sizeBtn.classList.remove('is-adding');
        alert('Sorry, something went wrong adding this to cart.');
      });
  });

  // Revert when mouse leaves the tile (only fire on the tile itself, not children)
  document.addEventListener('mouseleave', function (e) {
    if (!e.target.classList || !e.target.classList.contains('grid-product')) return;
    revertTile(e.target);
  }, true);
})();
// Clean up leftover body/html classes when cart drawer closes (bo-custom)
(function () {
  var cartDrawer = document.getElementById('CartDrawer');
  if (!cartDrawer) return;

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName !== 'class') return;
      var wasOpen = m.oldValue && m.oldValue.indexOf('is-open') !== -1;
      var nowOpen = cartDrawer.classList.contains('is-open');
      if (wasOpen && !nowOpen) {
        document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-cart');
        document.body.classList.remove('js-drawer-open');
      }
    });
  });

  observer.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['class'],
    attributeOldValue: true
  });
})();

/* =====================
   ATTITUDE GRID — Mobile tap to expand
   ===================== */
(function () {
  function initAttitudeTap() {
    document.addEventListener('click', function (e) {
      // Only do this on mobile
      if (window.innerWidth > 768) return;

      var btn = e.target.closest('.attitude-grid__card-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        var item = btn.closest('.attitude-grid__item');
        if (!item) return;

        // Close any other expanded tiles
        document.querySelectorAll('.attitude-grid__item.is-expanded').forEach(function (el) {
          if (el !== item) el.classList.remove('is-expanded');
        });

        // Toggle current
        item.classList.toggle('is-expanded');
        return;
      }

      // Tap outside any expanded tile → collapse all
      if (!e.target.closest('.attitude-grid__item.is-expanded')) {
        document.querySelectorAll('.attitude-grid__item.is-expanded').forEach(function (el) {
          el.classList.remove('is-expanded');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAttitudeTap);
  } else {
    initAttitudeTap();
  }
})();